/* ==========================================================================
   Mega Menu Header — Behavior
   ========================================================================== */
(function () {
  'use strict';

  class MegaMenu {
    constructor(navBar) {
      this.navBar = navBar;
      this.wrapper = navBar.closest('.mega-menu-header-wrapper');
      this.backdrop = this.wrapper && this.wrapper.querySelector('.mega-menu-backdrop');
      this.hoverTimeout = null;
      this.init();
    }
    init() {
      if (this.backdrop && this.backdrop.parentElement !== document.body) {
        document.body.appendChild(this.backdrop);
      }
      this.navBar.classList.add('hover-disabled');
      this.armPointerUnlock();
      this.positionBackdrop();
      window.addEventListener('resize', () => this.positionBackdrop());
      window.addEventListener('scroll', () => this.positionBackdrop());
      const items = this.navBar.querySelectorAll('.nav-item.has-mega-menu');
      items.forEach((item) => {
        item.addEventListener('mouseenter', () => {
          this.preselectFirst(item);
          this.showBackdrop();
        });
        item.addEventListener('mouseleave', () => this.scheduleBackdropHide());
      });
      this.navBar.querySelectorAll('.mega-menu').forEach((menu) => {
        menu.addEventListener('mouseenter', () => this.showBackdrop());
        menu.addEventListener('mouseleave', () => this.scheduleBackdropHide());
      });
      this.navBar.querySelectorAll('.mega-menu-category').forEach((cat) => {
        cat.addEventListener('mouseenter', () => this.activateCategory(cat));
      });
    }
    positionBackdrop() {
      if (!this.backdrop || !this.wrapper) return;
      const rect = this.wrapper.getBoundingClientRect();
      this.backdrop.style.top = rect.bottom + 'px';
    }
    showBackdrop() {
      if (!this.backdrop) return;
      clearTimeout(this.backdropTimeout);
      this.positionBackdrop();
      this.backdrop.classList.add('is-active');
    }
    scheduleBackdropHide() {
      if (!this.backdrop) return;
      clearTimeout(this.backdropTimeout);
      this.backdropTimeout = setTimeout(() => {
        this.backdrop.classList.remove('is-active');
      }, 100);
    }
    armPointerUnlock() {
      let startX = null;
      let startY = null;
      const handler = (e) => {
        if (startX === null) {
          startX = e.clientX;
          startY = e.clientY;
          return;
        }
        if (Math.hypot(e.clientX - startX, e.clientY - startY) > 10) {
          this.navBar.classList.remove('hover-disabled');
          document.removeEventListener('mousemove', handler);
        }
      };
      document.addEventListener('mousemove', handler);
    }
    preselectFirst(item) {
      const menu = item.querySelector('.mega-menu');
      if (!menu) return;
      menu.querySelectorAll('.mega-menu-category').forEach((c) => c.classList.remove('active'));
      menu.querySelectorAll('.mega-menu-subcategories').forEach((s) => s.classList.remove('active'));
      const firstCat = menu.querySelector('.mega-menu-category');
      if (!firstCat) return;
      firstCat.classList.add('active');
      const key = firstCat.getAttribute('data-submenu');
      if (!key) return;
      const panel = menu.querySelector('[data-parent="' + CSS.escape(key) + '"]');
      if (panel) panel.classList.add('active');
    }
    activateCategory(cat) {
      const menu = cat.closest('.mega-menu');
      if (!menu) return;
      clearTimeout(this.hoverTimeout);
      menu.querySelectorAll('.mega-menu-category').forEach((c) => c.classList.remove('active'));
      cat.classList.add('active');
      this.hoverTimeout = setTimeout(() => {
        menu.querySelectorAll('.mega-menu-subcategories').forEach((s) => s.classList.remove('active'));
        const key = cat.getAttribute('data-submenu');
        if (!key) return;
        const panel = menu.querySelector('[data-parent="' + CSS.escape(key) + '"]');
        if (panel) panel.classList.add('active');
      }, 50);
    }
  }

  class MobileMenu {
    constructor() {
      this.toggle = document.getElementById('mobileMenuToggle');
      this.menu = document.getElementById('mobileMenu');
      this.overlay = document.getElementById('mobileMenuOverlay');
      this.close = document.getElementById('mobileMenuClose');
      if (!this.toggle || !this.menu) {
        console.warn('[MobileMenu] Toggle or menu element not found');
        return;
      }
      this.bind();
    }
    bind() {
      this.toggle.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
      if (this.close) {
        this.close.addEventListener('click', (e) => {
          e.preventDefault();
          this.closeMenu();
        });
      }
      if (this.overlay) {
        this.overlay.addEventListener('click', () => this.closeMenu());
      }
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.menu.classList.contains('is-active')) {
          this.closeMenu();
        }
      });
      const submenuButtons = this.menu.querySelectorAll('.mobile-nav-item.has-submenu > button.mobile-nav-link');
      submenuButtons.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const item = btn.closest('.mobile-nav-item');
          if (!item) return;
          const isOpen = item.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', String(isOpen));
        });
      });
    }
    open() {
      this.menu.classList.add('is-active');
      if (this.overlay) this.overlay.classList.add('is-active');
      this.menu.setAttribute('aria-hidden', 'false');
      this.toggle.setAttribute('aria-expanded', 'true');
      this.toggle.setAttribute('aria-label', 'Menü schließen');
      document.body.style.overflow = 'hidden';
    }
    closeMenu() {
      this.menu.classList.remove('is-active');
      if (this.overlay) this.overlay.classList.remove('is-active');
      this.menu.setAttribute('aria-hidden', 'true');
      this.toggle.setAttribute('aria-expanded', 'false');
      this.toggle.setAttribute('aria-label', 'Menü öffnen');
      document.body.style.overflow = '';
    }
  }

  function init() {
    const navBar = document.querySelector('.nav-bar');
    if (navBar) new MegaMenu(navBar);
    new MobileMenu();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();